import type { AwsOidcComponents } from "@p0security/integrations-aws-oidc-shared/components";
import { p0OidcGrantRoleTerraform } from "@p0security/integrations-aws-oidc-shared/policy";
import type { FrontendInstaller } from "@p0security/integrations-installer";
import { installedItems } from "@p0security/shared/install/installed";
import type { NewConfig } from "@p0security/shared/integrations/shared";

const FEATURE_FLAG_ROLE_POOL_SIZE = "awsRolePoolSize";

export const awsOidcInstaller: FrontendInstaller<typeof AwsOidcComponents> = {
  components: {
    identity: {
      instructions: (context, id, item) => {
        const roleCount = context.featureFlags?.[
          FEATURE_FLAG_ROLE_POOL_SIZE
        ] as number;
        return {
          help: <>Install this to enable agentic access via OIDC:</>,
          commands: {
            iac: [
              {
                command: p0OidcGrantRoleTerraform(context, {
                  item,
                  installName: id,
                  roleCount,
                }),
              },
            ],
          },
        };
      },
      items: {
        accountId: {
          optionProvider: async ({ installed }) =>
            Object.keys(
              "aws" in installed
                ? installedItems<string, NewConfig>("iam-write", installed.aws)
                : {}
            ).map((id) => ({ id })),
        },
      },
    },
  },
};
